"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.nestedNavigationDataSelectorId = void 0;
exports.nestedNavigationDataSelectorId = {
    main: 'nested-navigation',
    itemStringPartId: 'nested-navigation-item'
};
//# sourceMappingURL=nestedNavigationDataSelectorId.js.map